<template>
  <div class="py-4 container-fluid">
    <div class="row" v-if="product">
      <div class="col-lg-6">
        <div class="d-flex align-items-center">
          <button
            class="btn btn-icon-only btn-link text-dark mb-0 me-2"
            @click="$emit('close')"
          >
            <i class="material-icons text-lg">arrow_back</i>
          </button>
          <h4 class="mb-0">Edit Product: {{ product.name }}</h4>
        </div>
        <p class="ms-5">
          Update the product information and manage its variations.
        </p>
      </div>
      <div
        class="text-right col-lg-6 d-flex flex-column justify-content-center"
      >
        <button
          type="button"
          class="mt-2 mb-0 btn bg-gradient-success ms-lg-auto me-lg-0 me-auto mt-lg-0"
          @click="onSave"
        >
          Save
        </button>
      </div>
    </div>
    <div class="mt-4 row" v-if="product">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <h5 class="font-weight-bolder">Product Information</h5>
            <div class="row mt-4">
              <div class="col-12 col-sm-6">
                <material-input id="name" v-model="product.name" variant="dynamic" label="Name" />
              </div>
              <div class="mt-3 col-12 col-sm-6 mt-sm-0">
                <material-input id="originalPrice" v-model="product.originalPrice" variant="dynamic" label="Price" />
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-6">
                <material-input id="discount" v-model="product.discount" variant="dynamic" label="Discount (%)" />
              </div>
              <div class="col-6">
                <material-input id="discountedPrice" v-model="product.discountedPrice" variant="dynamic" label="Discounted Price" />
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-sm-6">
                <label class="ms-0">Category</label>
                <select
                  id="choices-category-edit"
                  class="form-control"
                  name="choices-category"
                  v-model="product.categoryId"
                >
                  <option v-for="cat in categories" :key="cat.id" :value="cat.id">{{ cat.name }}</option>
                </select>
              </div>
              <div class="col-sm-6 mt-3 mt-sm-0">
                <label class="ms-0">Brand</label>
                <select
                  id="choices-brand-edit"
                  class="form-control"
                  name="choices-brand"
                  v-model="product.brand"
                >
                  <option v-for="brand in brands" :key="brand.id" :value="brand.id">{{ brand.name }}</option>
                </select>
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-sm-6">
                <label class="ms-0">Atributo Primario</label>
                <select
                  id="choices-primary-attr"
                  class="form-control"
                  name="choices-primary-attr"
                  v-model="primaryAttr"
                >
                  <option value="">None</option>
                  <option v-for="group in attributeGroups" :key="group.id" :value="group.id.toString()">{{ group.name }}</option>
                </select>
              </div>
              <div class="col-sm-6 mt-3 mt-sm-0">
                <label class="ms-0">Atributo Secundario</label>
                <select
                  id="choices-secondary-attr"
                  class="form-control"
                  name="choices-secondary-attr"
                  v-model="secondaryAttr"
                >
                  <option value="">None</option>
                  <option v-for="group in attributeGroups" :key="group.id" :value="group.id.toString()">{{ group.name }}</option>
                </select>
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-12">
                <label class="ms-0">Description</label>
                <div id="edit-description-edit" class="h-50">
                  {{ product.description }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="mt-4 row" v-if="product">
      <div class="col-lg-4">
        <div class="card h-100">
          <div class="card-header p-0 position-relative mx-3 text-center">
            <a class="d-block blur-shadow-image">
              <img
                :src="selectedItemImage || '@/assets/img/products/product-11.jpg'"
                alt="img-blur-shadow"
                class="img-fluid shadow border-radius-lg"
                style="max-height: 250px; object-fit: contain;"
              />
            </a>
          </div>
          <div class="card-body text-center">
            <div class="row mt-3 text-start">
              <div class="col-12">
                <label class="ms-0">Image Type</label>
                <select id="choices-image-type" class="form-control" v-model="imageType">
                  <option value="1">Cover (1)</option>
                  <option value="2">Back Cover (2)</option>
                </select>
              </div>
            </div>
            
            <!-- Bulk upload target group selection -->
            <div class="row mt-3 text-start" v-if="!selectedItem">
              <div class="col-12">
                <label class="ms-0">Select Attribute Group for Bulk Apply</label>
                <select id="choices-bulk-group-type" class="form-control" v-model="selectedBulkAttrGroupType">
                  <option value="primary">Primary: {{ primaryAttrGroupName }}</option>
                  <option value="secondary">Secondary: {{ secondaryAttrGroupName }}</option>
                </select>
              </div>
            </div>

            <!-- Bulk upload warning alert -->
            <material-alert v-if="!selectedItem && (selectedFile || imageUrl)" color="warning" class="mt-3 text-start" icon="warning">
              <span class="text-xs">Esta foto se asignara a todos los items de producto con el atributo grupal seleccionado.</span>
            </material-alert>

            <div class="row mt-3 text-start">
              <div class="col-12">
                <div class="form-check form-switch d-flex align-items-center mb-3">
                  <input
                    id="upload-mode"
                    class="form-check-input"
                    type="checkbox"
                    v-model="isUrlMode"
                  />
                  <label class="form-check-label mb-0 ms-3" for="upload-mode">Upload from URL</label>
                </div>
              </div>
            </div>

            <div v-if="isUrlMode" class="row mt-2 text-start">
              <div class="col-12">
                <material-input id="image-url" v-model="imageUrl" variant="dynamic" label="Image URL" :disabled="isUploading" />
              </div>
            </div>

            <div class="mt-4 mx-auto">
              <div v-if="!isUrlMode">
                <input type="file" ref="fileInput" class="d-none" @change="onFileChange" accept="image/*" />
                <button
                  class="btn bg-gradient-info btn-sm mb-0 me-2"
                  type="button"
                  @click="$refs.fileInput.click()"
                  :disabled="isUploading"
                >
                  Select Photo
                </button>
                <button
                  class="btn bg-gradient-success btn-sm mb-0"
                  type="button"
                  @click="onUpload"
                  :disabled="!selectedFile || isUploading"
                >
                  {{ isUploading ? 'Uploading...' : 'Upload File' }}
                </button>
                <p class="text-xs mt-2" v-if="selectedFile">{{ selectedFile.name }}</p>
              </div>
              <div v-else>
                <button
                  class="btn bg-gradient-success btn-sm mb-0"
                  type="button"
                  @click="onUpload"
                  :disabled="!imageUrl || isUploading"
                >
                  {{ isUploading ? 'Uploading...' : 'Upload from URL' }}
                </button>
              </div>
            </div>
            
            <h5 class="font-weight-normal mt-4">Item Image</h5>
            <p class="text-sm" v-if="selectedItem">
              Editing images for SKU: {{ selectedItem.sku }}
            </p>
            <p class="text-sm" v-else>
              Bulk upload mode (by attribute group)
            </p>
          </div>
        </div>
      </div>
      <div class="col-lg-8 mt-lg-0 mt-4">
        <div class="card h-100">
          <div class="card-header pb-0">
            <h5 class="mb-0">Product Variations (Items)</h5>
          </div>
          <div class="table-responsive">
            <table id="product-items-datatable" class="table table-flush">
              <thead class="thead-light">
                <tr>
                  <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Attribute Group</th>
                  <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Attribute Value</th>
                  <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Final Price</th>
                  <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Quantity</th>
                  <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Status</th>
                  <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in productItems" :key="item.id" :class="{'bg-light': selectedItem && selectedItem.id === item.id}">
                  <td class="text-sm">{{ item.primaryAttribute ? item.primaryAttribute.attributeGroupName : '-' }}</td>
                  <td class="text-sm">{{ item.primaryAttribute ? item.primaryAttribute.attributeGroupValueName : '-' }}</td>
                  <td class="text-sm">{{ item.originalPrice }}</td>
                  <td class="text-sm">{{ item.quantity }}</td>
                  <td class="text-sm">
                    <span :class="['badge', item.enable ? 'bg-success' : 'bg-danger']">
                      {{ item.enable ? 'Enabled' : 'Disabled' }}
                    </span>
                  </td>
                  <td class="text-sm">
                    <button class="btn btn-link text-secondary mb-0" @click="selectItem(item)">
                       <i class="material-icons text-lg">edit</i>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <!-- Edit Item Form -->
    <div class="mt-4 row" v-if="selectedItem">
      <div class="col-12">
        <div class="card">
          <div class="card-header pb-0">
            <h5 class="mb-0">Edit Item: {{ selectedItem.sku }}</h5>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-md-4">
                <material-input id="item-sku" v-model="selectedItem.sku" variant="dynamic" label="SKU" />
              </div>
              <div class="col-md-4">
                <material-input id="item-price" v-model="selectedItem.originalPrice" variant="dynamic" label="Original Price" />
              </div>
              <div class="col-md-4">
                <material-input id="item-discounted" v-model="selectedItem.discountedPrice" variant="dynamic" label="Discounted Price" />
              </div>
            </div>
            <div class="row mt-3">
              <div class="col-md-4">
                <material-input id="item-quantity" v-model="selectedItem.quantity" variant="dynamic" label="Quantity" />
              </div>
              <div class="col-md-4">
                <div class="form-check form-switch d-flex align-items-center mb-3">
                  <input
                    id="item-enable"
                    class="form-check-input"
                    type="checkbox"
                    v-model="selectedItem.enable"
                  />
                  <label class="form-check-label mb-0 ms-3" for="item-enable">Enabled</label>
                </div>
              </div>
            </div>
            <div class="row mt-3">
              <div class="col-12 text-end">
                <button class="btn bg-gradient-dark mb-0 me-2" @click="selectedItem = null">Cancel</button>
                <button class="btn bg-gradient-success mb-0" @click="onSaveItem">Save Item</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable prettier/prettier */
import Quill from "quill";
import Choices from "choices.js";
import MaterialInput from "@/components/MaterialInput.vue";
import MaterialAlert from "@/components/MaterialAlert.vue";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "EditProduct",
  components: { MaterialInput, MaterialAlert },
  props: {
    productId: {
      type: [String, Number],
      required: true,
    },
  },
  data() {
    return {
      quill: null,
      choices: {},
      primaryAttr: "",
      secondaryAttr: "",
      selectedItem: null,
      selectedItemImage: null,
      apiUrl: process.env.VUE_APP_API_BASE_URL,
      imageType: "1",
      selectedFile: null,
      imageUrl: "",
      isUrlMode: true,
      isUploading: false,
      selectedBulkAttrGroupType: "primary",
    };
  },
  computed: {
    ...mapGetters("product", {
      product: "getProduct",
      productItems: "getProductItems",
      categories: "getCategories",
      brands: "getBrands",
      attributeGroups: "getAttributeGroups",
      productAttributeGroups: "getProductAttributeGroups",
      itemImages: "getItemImages",
    }),
    primaryAttrGroupName() {
      if (!this.primaryAttr || !this.attributeGroups) return "Primary Attribute";
      const group = this.attributeGroups.find(g => g.id.toString() === this.primaryAttr);
      return group ? group.name : "Primary Attribute";
    },
    secondaryAttrGroupName() {
      if (!this.secondaryAttr || !this.attributeGroups) return "Secondary Attribute";
      const group = this.attributeGroups.find(g => g.id.toString() === this.secondaryAttr);
      return group ? group.name : "Secondary Attribute";
    },
    currentBulkAttrGroupId() {
      return this.selectedBulkAttrGroupType === 'primary' ? this.primaryAttr : this.secondaryAttr;
    }
  },
  watch: {
    selectedItem(newVal) {
      this.selectedFile = null;
      this.imageUrl = "";
      if (!newVal) {
        this.$nextTick(() => {
          this.refreshBulkGroupTypeChoices();
        });
        this.updateBulkPreviewImage();
      }
    },
    selectedBulkAttrGroupType() {
      this.selectedFile = null;
      this.imageUrl = "";
    },
    imageType() {
      if (this.selectedItem) {
        this.selectItem(this.selectedItem);
      } else {
        this.updateBulkPreviewImage();
      }
    }
  },
  async mounted() {
    await Promise.all([
      this.getProduct(this.productId),
      this.getProductItems(this.productId),
      this.getProductAttributeGroups(this.productId),
      this.getCategories(),
      this.getBrands(),
      this.getAttributeGroups(),
    ]);

    if (this.productAttributeGroups) {
      this.primaryAttr = this.productAttributeGroups.primaryGroupId ? this.productAttributeGroups.primaryGroupId.toString() : "";
      this.secondaryAttr = this.productAttributeGroups.secondaryGroupId ? this.productAttributeGroups.secondaryGroupId.toString() : "";
    }

    this.$nextTick(() => {
      this.initPlugins();
      if (!this.selectedItem) {
        this.updateBulkPreviewImage();
      }
    });
  },
  beforeUnmount() {
    if (this.quill) {
      this.quill = null;
    }
    Object.values(this.choices).forEach(choice => {
      if (choice && typeof choice.destroy === 'function') {
        choice.destroy();
      }
    });
  },
  methods: {
    ...mapActions("product", [
      "getProduct",
      "getProductItems",
      "getProductAttributeGroups",
      "getItemImages",
      "getCategories",
      "getBrands",
      "getAttributeGroups",
      "updateProduct",
      "updateProductItem",
      "uploadItemPhoto",
      "uploadItemPhotoByUrl",
      "uploadPhotoByAttributeGroup",
      "uploadPhotoByAttributeGroupByUrl"
    ]),
    async updateBulkPreviewImage() {
      if (this.selectedItem || !this.productItems || this.productItems.length === 0) {
        return;
      }
      const firstItem = this.productItems[0];
      const images = await this.getItemImages(firstItem.id);
      if (images && images.length > 0) {
        const targetType = parseInt(this.imageType);
        const img = images.find(img => img.coverOrder === targetType);
        if (img && img.image) {
          this.selectedItemImage = `${this.apiUrl}/image/${img.image.name}`;
        } else {
          this.selectedItemImage = null;
        }
      } else {
        this.selectedItemImage = null;
      }
    },
    initPlugins() {
      if (document.getElementById("edit-description-edit")) {
        this.quill = new Quill("#edit-description-edit", {
          theme: "snow",
        });
        if (this.product && this.product.description) {
           this.quill.root.innerHTML = this.product.description;
        }
      }

      this.choices['category'] = this.getChoices("choices-category-edit");
      this.choices['brand'] = this.getChoices("choices-brand-edit");
      this.choices['primary'] = this.getChoices("choices-primary-attr");
      this.choices['secondary'] = this.getChoices("choices-secondary-attr");
      this.choices['imageType'] = this.getChoices("choices-image-type");
      this.refreshBulkGroupTypeChoices();
    },
    refreshBulkGroupTypeChoices() {
      if (this.choices['bulkGroupType']) {
        this.choices['bulkGroupType'].destroy();
      }
      if (document.getElementById("choices-bulk-group-type")) {
        this.choices['bulkGroupType'] = this.getChoices("choices-bulk-group-type");
      }
    },
    getChoices(id) {
      if (document.getElementById(id)) {
        var element = document.getElementById(id);
        return new Choices(element, {
          searchEnabled: true,
          shouldSort: false,
          allowHTML: true,
        });
      }
      return null;
    },
    onFileChange(e) {
      const files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      this.selectedFile = files[0];
    },
    async onUpload() {
      if (!this.isUrlMode && !this.selectedFile) return;
      if (this.isUrlMode && !this.imageUrl) return;

      this.isUploading = true;
      try {
        if (this.selectedItem) {
          if (this.isUrlMode) {
            await this.uploadItemPhotoByUrl({
              itemId: this.selectedItem.id,
              url: this.imageUrl,
              coverOrder: parseInt(this.imageType)
            });
          } else {
            await this.uploadItemPhoto({
              itemId: this.selectedItem.id,
              file: this.selectedFile,
              coverOrder: parseInt(this.imageType)
            });
          }
          await this.selectItem(this.selectedItem);
        } else if (this.currentBulkAttrGroupId) {
          if (this.isUrlMode) {
            await this.uploadPhotoByAttributeGroupByUrl({
              productId: this.product.id,
              attributeGroupId: this.currentBulkAttrGroupId,
              url: this.imageUrl,
              coverOrder: parseInt(this.imageType)
            });
          } else {
            await this.uploadPhotoByAttributeGroup({
              productId: this.product.id,
              attributeGroupId: this.currentBulkAttrGroupId,
              file: this.selectedFile,
              coverOrder: parseInt(this.imageType)
            });
          }
          await this.updateBulkPreviewImage();
        } else {
          this.$swal.fire("Warning", "Please select an item or an attribute group for bulk upload", "warning");
          return;
        }

        this.$swal.fire("Success", "Image uploaded successfully", "success");
        this.selectedFile = null;
        this.imageUrl = "";
        if (this.$refs.fileInput) {
          this.$refs.fileInput.value = '';
        }
      } catch (error) {
        this.$swal.fire("Error", "Could not upload image", "error");
      } finally {
        this.isUploading = false;
      }
    },
    async selectItem(item) {
      this.selectedItem = { ...item };
      this.selectedItemImage = null;
      const images = await this.getItemImages(item.id);
      if (images && images.length > 0) {
        const cover = images.find(img => img.coverOrder === parseInt(this.imageType)) || images.find(img => img.coverOrder === 1) || images[0];
        if (cover && cover.image) {
          this.selectedItemImage = `${this.apiUrl}/image/${cover.image.name}`;
        }
      }
    },
    async onSaveItem() {
      try {
        await this.updateProductItem({ id: this.selectedItem.id, itemDTO: this.selectedItem });
        this.$swal.fire("Success", "Item updated successfully", "success");
        this.selectedItem = null;
      } catch (error) {
        this.$swal.fire("Error", "Could not update item", "error");
      }
    },
    async onSave() {
      const description = this.quill ? this.quill.root.innerHTML : this.product.description;
      
      const productDTO = {
        ...this.product,
        description: description,
      };

      try {
        await this.updateProduct({ id: this.product.id, productDTO });
        this.$swal.fire("Success", "Product updated successfully", "success");
      } catch (error) {
        this.$swal.fire("Error", "Could not update product", "error");
      }
    }
  },
};
</script>
